/** Open roles. Firm-level only; no individual profiles. */
export type OpenRole = {
  role: string;
  meta: string;
  summary: string;
};

export const openRoles: OpenRole[] = [
  {
    role: "Product lead",
    meta: "Per engagement · Remote · Worldwide",
    summary: "Own scope, roadmap and the definition of done alongside the client's product team.",
  },
  {
    role: "AI & data engineer",
    meta: "Per engagement · Remote · Worldwide",
    summary: "Put models, retrieval and the data behind them into production, with monitoring and governance.",
  },
  {
    role: "Systems architect",
    meta: "Per engagement · Remote · Worldwide",
    summary: "Integrate ERP, CRM, commerce and partner APIs in a live business without stopping the business.",
  },
  {
    role: "Operations lead",
    meta: "Per engagement · Remote · Worldwide",
    summary: "Run planning, procurement or fulfilment through the rebuild and lead the handover.",
  },
];

/** What we look for, keyed by the role names in team.ts engagementRoles. */
export const roleCriteria: Record<string, string> = {
  "Senior partner": "10+ years leading product or operations transformations; has owned a P&L or a programme budget.",
  "Product lead": "Has shipped B2B products to production and run a roadmap with engineering.",
  "AI & data engineer": "Has put LLM, retrieval or ML systems into production with monitoring and governance.",
  "Systems architect": "Has integrated ERP, CRM, commerce or partner APIs in a live business.",
  "Operations lead": "Has run planning, procurement or fulfilment and led a handover to an internal team.",
};

export const CAREERS_EMAIL = "Admin@skandortech.ai";

export const applyHref = (role: string) =>
  `mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(`Application: ${role}`)}`;
